// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_o5V","cls2":"UserTaggingPingBodyStyles-cls2_MNN UserTaggingPingBodyStyles-cls1_o5V"};